import { Link } from "react-router-dom";
import { Facebook, Instagram, MessageCircle, Heart } from "lucide-react";
import { useLang } from "@/i18n";
import { SECTIONS } from "@/config";
import { Logo } from "@/components/Navbar";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="bg-mare text-calce mt-0" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid gap-12 md:grid-cols-3">
        <div>
          <span className="inline-block bg-calce rounded-2xl px-4 py-2.5"><Logo dark /></span>
          <p className="mt-4 font-accent text-2xl text-sabbia">{t("footer.tag")}</p>
          <div className="flex gap-3 mt-6">
            <a data-testid="social-facebook" href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook"
              className="w-10 h-10 rounded-full bg-white/10 hover:bg-terracotta flex items-center justify-center transition-colors">
              <Facebook className="w-4 h-4" />
            </a>
            <a data-testid="social-instagram" href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram"
              className="w-10 h-10 rounded-full bg-white/10 hover:bg-terracotta flex items-center justify-center transition-colors">
              <Instagram className="w-4 h-4" />
            </a>
            <a data-testid="social-whatsapp" href="https://wa.me/390566260000" target="_blank" rel="noreferrer" aria-label="WhatsApp"
              className="w-10 h-10 rounded-full bg-white/10 hover:bg-pineta flex items-center justify-center transition-colors">
              <MessageCircle className="w-4 h-4" />
            </a>
          </div>
        </div>
        <div>
          <h4 className="text-xs tracking-[0.2em] uppercase font-bold text-turchese mb-4">{t("footer.sections")}</h4>
          <div className="grid grid-cols-2 gap-x-6 gap-y-2">
            {SECTIONS.map((s) => (
              <Link key={s.type} to={s.path} data-testid={`footer-${s.type}`} className="text-sm text-calce/80 hover:text-sabbia transition-colors">
                {t(s.navKey)}
              </Link>
            ))}
          </div>
        </div>
        <div>
          <h4 className="text-xs tracking-[0.2em] uppercase font-bold text-turchese mb-4">{t("footer.project")}</h4>
          <div className="flex flex-col gap-2 text-sm text-calce/80">
            <Link to="/chi-siamo" data-testid="footer-about" className="hover:text-sabbia transition-colors">{t("nav.about")}</Link>
            <Link to="/sondaggio" data-testid="footer-survey" className="hover:text-sabbia transition-colors">{t("nav.survey")}</Link>
            <Link to="/mappa" data-testid="footer-map" className="hover:text-sabbia transition-colors">{t("nav.map")}</Link>
            <a href="mailto:info@likefollonica.it" data-testid="footer-email" className="hover:text-sabbia transition-colors">info@likefollonica.it</a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5 flex flex-wrap items-center justify-between gap-3 text-xs text-calce/60">
          <span>© 2026 Follonica Like</span>
          <span className="font-accent text-base text-sabbia/80 flex items-center gap-1.5">
            {t("footer.made")} <Heart className="w-3 h-3 fill-terracotta text-terracotta" />
          </span>
        </div>
      </div>
    </footer>
  );
}
